import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {makeRequest, displayMessage} from  'actions';
import {FETCH_FOCUS_AREAS, UPDATE_FOCUS_AREA, ADD_FOCUS_AREA, DELETE_FOCUS_AREA,} from "actions/actionTypes";
import PropTypes from 'prop-types';
import withDragAndDropContext from'shared/withDragAndDropContext';
import FaPencilSquare from 'react-icons/lib/fa/pencil-square';
import {base64ToHex}  from 'util/Utils';
import Select   from 'react-select'
import config from  '../../../config';
import {
    SortableTreeWithoutDndContext as SortableTree,
    getNodeAtPath,
    changeNodeAtPath,
    removeNodeAtPath
} from 'react-sortable-tree';
import {Button, Modal, FormGroup, ControlLabel, FormControl, Form, Row, Col} from 'react-bootstrap';
import {v4 as uuidv4}  from 'uuid'
import {DropTarget} from 'react-dnd';
import { getAllowedAgeGroups, removeInvalidAgeGroups } from '../../shared/sharedMethods';
const trashAreaType = 'yourNodeType';
const getNodeKey = ({treeIndex}) => treeIndex;

const trashAreaSpec = {
    // The endDrag handler on the tree source will use some of the properties of
    // the source, like node, treeIndex, and path to determine where it was before.
    // The treeId must be changed, or it interprets it as dropping within itself.
    drop: (props, monitor) => ({...monitor.getItem(), treeId: 'trash'}),
};
const trashAreaCollect = (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({shallow: true}),
});

// The component will sit around the tree component and catch
// nodes dragged out
class trashAreaBaseComponent extends Component {
    render() {
        const {connectDropTarget, children, isOver} = this.props;

        return connectDropTarget(
            <div
                style={{
                    // height: '100vh',
                    padding: '50px 50px 50px 0',

                    background: isOver ? 'pink' : 'transparent',
                }}
            >
                {children}
            </div>
        );
    }
}
trashAreaBaseComponent.propTypes = {
    connectDropTarget: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    isOver: PropTypes.bool.isRequired,
};
const TrashAreaComponent = DropTarget(
    trashAreaType,
    trashAreaSpec,
    trashAreaCollect
)(trashAreaBaseComponent);


class AdminCategoriesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {

            showCategoryModal: false,
            currentRecord: {},
            existingSubcategories: [],
            importDescriptionsInProgress:false,
            categoriesNotUpdated: [],
            treeData: [],
            pending:false,
        };
        this.saveCategories=  _.throttle(this.saveCategories,2000, {
            'leading': true,
            'trailing': false
        });
        this.importDescriptions=  _.throttle(this.importDescriptions,2000, {
            'leading': true,
            'trailing': false
        });
    }

    componentWillMount() {
         var methodData = {
             'endpoint': '/categories',
            'not_display_success_message': true,
        };
        this.props.makeRequest({}, methodData).then(response => {
           this.prepareCategoryTree(response.data.data)
        })
        this.props.makeRequest({'type': 'CategoryTagsList'}, {
            "endpoint": "/gbg_products_data",
            type: 'post',
            'not_display_success_message': true,
        }).then((response) => {
            this.setState({
                allCategoryTags: _.map(_.get(response.data, 'data', []).sort(), item => {
                    return {'value': item, 'label': item}
                })
            })
        }).catch(err => {
        });

    }
    prepareCategoryTree(categories){
        var categoriesByID = {};
        _.forEach(categories, function (category, index) {
            if (category.AncestorCategories.length > 0) {
                /* it is subcategory */
                _.forEach(category.AncestorCategories, function (parentCategory, index) {

                    if (_.isUndefined(categoriesByID[parentCategory.CategoryID])) {

                        categoriesByID[parentCategory.CategoryID] = {
                            children: [{
                                _id: base64ToHex(category._id),
                                title: category.CategoryName,
                                subtitle: category.TagName,
                                AgeGroups:_.get(category, ['AgeGroups'],  []),
                                CategoryTags:_.get(category, ['CategoryTags'],  []),
                                RankOrder: parentCategory.RankOrder,
                            }]
                        }
                    } else {
                        categoriesByID[parentCategory.CategoryID].children.push({
                            _id: base64ToHex(category._id),
                            title: category.CategoryName,
                            subtitle: category.TagName,
                            AgeGroups:_.get(category, ['AgeGroups'],  []),
                            CategoryTags:_.get(category, ['CategoryTags'],  []),
                            RankOrder: parentCategory.RankOrder,
                        })
                    }
                })
            } else { /* it is top-level category */
                if (_.isUndefined(categoriesByID[category._id])) {
                    categoriesByID[category._id] = {
                        _id: base64ToHex(category._id),
                        title: category.CategoryName,
                        subtitle: category.TagName,
                        AgeGroups:_.get(category, ['AgeGroups'],  []),
                        RankOrder: category.RankOrder,
                        children: []
                    }
                } else {
                    categoriesByID[category._id]._id =      base64ToHex(category._id),
                        categoriesByID[category._id].title = category.CategoryName;
                    categoriesByID[category._id].subtitle = category.TagName
                    categoriesByID[category._id].AgeGroups =_.get(category, ['AgeGroups'],  [])
                    categoriesByID[category._id].CategoryTags =_.get(category, ['CategoryTags'],  [])
                     categoriesByID[category._id].RankOrder = category.RankOrder
                }

            }
        })
        var categoriesArray = _.map(categoriesByID, function (categoryData) {
            return {
                ...categoryData, children: _.sortBy(categoryData.children, [function (o) {
                    return o.RankOrder;
                }])
            }
        })
        var categoriesTreeSorted = _.sortBy(categoriesArray, [function (o) {
            return o.RankOrder;
        }]);
console.log('categoriesTreeSorted',categoriesTreeSorted );
        this.setState({
            treeData: categoriesTreeSorted,
           pending:false
        })
    }
    editCategory(node, path, currentNodeData) {
        console.log('getNodeAtPath', node, path, currentNodeData);
        this.setState({currentRecord: {...currentNodeData.node, newItem: false, node, path}, showCategoryModal: true})
    }

    addNewCategory() {
        this.setState({currentRecord: {title: '', subtitle: '', AgeGroups:[], CategoryTags:[],children: [], newItem: true}, showCategoryModal: true})
    }

    closeCategoryModal() {
        this.setState({currentRecord: {}, showCategoryModal: false})
    }

    closeImportDescriptionsModal() {
        this.setState({categoriesNotUpdated: []})
    }

    saveCategory() {

        if (this.state.currentRecord.title == '' || this.state.currentRecord.subtitle == '') {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Category Name or Tag can not be empty'
            });
        }
        // if (_.size(_.get(this.state.currentRecord, ['AgeGroups'], [])) == 0 ) {
        //     return this.props.displayMessage({
        //         'messageType': 'warning',
        //         'messageCode': 'Age groups are not specified'
        //     });
        // }
        if (this.state.currentRecord.newItem) {
            this.setState({
                treeData: _.concat(this.state.treeData, [this.state.currentRecord]),
                showCategoryModal: false
            })
        } else {
            this.setState(state => ({
                treeData: changeNodeAtPath({
                    treeData: state.treeData,
                    path: state.currentRecord.path,
                    getNodeKey: getNodeKey,
                    newNode: {
                        ...state.currentRecord.node,
                        title: state.currentRecord.title,
                        subtitle: state.currentRecord.subtitle,
                        AgeGroups: state.currentRecord.AgeGroups,
                        CategoryTags: state.currentRecord.CategoryTags,
                    },
                }),
                currentRecord: {},
                showCategoryModal: false,
            }))
        }
    }

    importDescriptions() {
        this.setState({importDescriptionsInProgress:true,pending:true })
        var methodData = {
            type: 'post',
            "endpoint": "/import_categories_descriptions",
            //  'not_display_success_message': true,
        };
        this.props.makeRequest({}, methodData).then(res => {
            console.log('res', res);
            if (res.data.categoriesNotUpdated) {
                this.setState({
                    categoriesNotUpdated: res.data.categoriesNotUpdated,
                    existingSubcategories: res.data.existingSubcategories ? res.data.existingSubcategories : [],
                    importDescriptionsInProgress:false,pending:false,
                })
                if (_.size(res.data.categoriesNotUpdated) == 0) {
                    return this.props.displayMessage({
                        'messageType': 'warning',
                        'messageCode': 'categoriesDescriptionsImported'
                    });
                }
            }

        }).catch(err=>{
            this.setState({
                 importDescriptionsInProgress:false,pending:false,
            })
        })

    }

    saveCategories() {
        this.setState({pending:true})
        var categoriesByTitleAndTagName = {};
        _.forEach(this.state.treeData, function (topLevelCategory, index) {
            var topLevelCategoryID = uuidv4();
            if (topLevelCategory._id) {
                topLevelCategoryID = topLevelCategory._id;
            }
            categoriesByTitleAndTagName['category'+topLevelCategory.title+topLevelCategory.subtitle] = {
                _id: topLevelCategoryID,
                CategoryName: topLevelCategory.title,
                TagName: topLevelCategory.subtitle,
                AgeGroups:_.get(topLevelCategory, ['AgeGroups'], []),
                CategoryTags:_.get(topLevelCategory, ['CategoryTags'], []),
                RankOrder: index + 1,
            }
            if (topLevelCategory.children && topLevelCategory.children.length > 0) {
                _.forEach(topLevelCategory.children, function (subCategory, subCategoryIndex) {
                    if (_.isUndefined(categoriesByTitleAndTagName['subcategory'+subCategory.title+subCategory.subtitle])) {
                        categoriesByTitleAndTagName['subcategory'+subCategory.title+subCategory.subtitle] = {
                            _id: subCategory._id,
                            CategoryName: subCategory.title,
                            TagName: subCategory.subtitle,
                            AgeGroups:_.get(subCategory, ['AgeGroups'], []),
                            CategoryTags:_.get(subCategory, ['CategoryTags'], []),
                            AncestorCategories: [{
                                CategoryID: topLevelCategoryID,
                                RankOrder: subCategoryIndex + 1,
                            }],
                        }
                    } else {
                        categoriesByTitleAndTagName['subcategory'+subCategory.title+subCategory.subtitle].AncestorCategories.push({
                             CategoryID: topLevelCategoryID,
                            RankOrder: subCategoryIndex + 1,
                        })
                    }
                })
            }
        })

        var categoriesToSave = _.values(categoriesByTitleAndTagName)
        categoriesToSave.forEach(item => item.AgeGroups = removeInvalidAgeGroups(item.AgeGroups))

        var methodData = {
            type: 'post',
            "endpoint": "/categories",
            messageData: {'#1#': 'Categories'},
            messageCode: 'recordUpdated'
        };
        this.props.makeRequest({categories: categoriesToSave}, methodData).then(response => {
            this.prepareCategoryTree(response.data.data)

        }).catch(err=>{
            this.state({pending:false})
        })

    }


    render() {
        console.log('this state', this.state  );
         return (
            <div >

                <Row  >
                    <Col xs={6} md={3} className="pleft15 top20 bot20">
                        <Button onClick={(event) => this.addNewCategory()} className="btn btn-primary">Add
                            Category</Button>
                    </Col>
                    <Col xs={6} md={3} className="top20  bot20">
                        <Button onClick={(event) => this.saveCategories()}
                                disabled={this.state.pending}
                                className="btn btn-primary">Save
                            Categories</Button>
                    </Col>
                    <Col xs={12} md={3} className="top20  bot20">
                        <Button disabled={this.state.importDescriptionsInProgress || this.state.pending}

                                onClick={(event) => this.importDescriptions()} className="btn btn-primary">Import
                            Descriptions</Button>
                    </Col>

                </Row>
                <TrashAreaComponent>
                    <Row style={{height: 600}}>
                        <SortableTree
                            treeData={this.state.treeData}
                            onChange={treeData => this.setState({treeData})}
                            generateNodeProps={({node, path}) => ({
                                buttons: [
                                    <button className="package-box__button-pict-box"
                                            onClick={() => this.editCategory(node, path, getNodeAtPath({
                                                treeData: this.state.treeData,
                                                path,
                                                getNodeKey,
                                            }))}>
                                        <FaPencilSquare
                                            className="right5 bot3 green"></FaPencilSquare>
                                    </button>
                                    // <FaTimesCircle className="deleteButton right5 bot3"
                                    //                onClick={() =>
                                    //                    this.setState(state => ({
                                    //                        treeData: removeNodeAtPath({
                                    //                            treeData: state.treeData,
                                    //                            path,
                                    //                            getNodeKey,
                                    //                        }),
                                    //                    }))
                                    //                }
                                    // ></FaTimesCircle>


                                ],
                            })}
                            dndType={trashAreaType}
                        />
                    </Row>
                </TrashAreaComponent>

                <Modal show={this.state.showCategoryModal} onHide={this.closeCategoryModal.bind(this)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{_.get(this.state.currentRecord, '_id') ? 'Edit category':'Add category'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form >
                            <Row >
                                <Col xs={12}>
                                    <FormGroup className=" bot20">
                                        <ControlLabel className="pleft0 col-xs-12  ptop5">Name</ControlLabel>
                                        <FormControl
                                            defaultValue={this.state.currentRecord.title}
                                            onChange={(e) => this.setState({
                                                currentRecord: {
                                                    ...this.state.currentRecord,
                                                    title: e.target.value
                                                }
                                            }) }
                                            type="text"/>
                                    </FormGroup>
                                    <FormGroup className=" bot20">
                                        <ControlLabel className="pleft0 col-xs-12  ptop5">Tag</ControlLabel>
                                        <FormControl
                                            defaultValue={this.state.currentRecord.subtitle}
                                            onChange={(e) => this.setState({
                                                currentRecord: {
                                                    ...this.state.currentRecord,
                                                    subtitle: e.target.value
                                                }
                                            }) }
                                            type="text"/>
                                    </FormGroup>
                                    <FormGroup className=" bot20">
                                        <ControlLabel className="pleft0 col-xs-12  ptop5">Age Groups</ControlLabel>
                                        <Select
                                             placeholder="Age groups"
                                             clearable={false}
                                             options={getAllowedAgeGroups()}
                                             multi
                                             onChange={(options) => {
                                                 this.setState({
                                                     currentRecord: {
                                                         ...this.state.currentRecord,
                                                         AgeGroups: _.map(options, 'value')
                                                     }
                                                 })
                                              }}
                                            value={_.get(this.state.currentRecord, ['AgeGroups'],  [])}
                                        />
                                    </FormGroup>
                                    <FormGroup className=" bot20">
                                        <ControlLabel className="pleft0 col-xs-12  ptop5">Tags</ControlLabel>
                                        <Select
                                            placeholder="Tags"
                                            clearable={false}
                                            options={this.state.allCategoryTags}
                                            multi
                                            onChange={(options) => {
                                                this.setState({
                                                    currentRecord: {
                                                        ...this.state.currentRecord,
                                                        CategoryTags: _.map(options, 'value')
                                                    }
                                                })
                                            }}
                                            value={_.get(this.state.currentRecord, ['CategoryTags'],  [])}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">

                                <Button className=" pull-right btn btn-primary right0" type="button"
                                        onClick={(e) => this.saveCategory()}>
                                    Save
                                </Button>
                                <Button className="pull-right btn  btn-default right20" type="button"
                                        onClick={(e) => this.closeCategoryModal() }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={_.size(this.state.categoriesNotUpdated) > 0 }
                    onHide={this.closeImportDescriptionsModal.bind(this)}
                >
                    <Modal.Header closeButton>
                     </Modal.Header>
                    <Modal.Body style={{height: 400, overflow: 'scroll'}}>
                        {_.size(this.state.categoriesNotUpdated) > 0 &&
                        <div>
                                 <h4 className="top0 bot15">The following categories are not updated:</h4>
                            { this.state.categoriesNotUpdated.map((categoryNotUpdated, index) => {
                                return <div>{categoryNotUpdated}</div>
                            })}
                        </div>
                        }

                        {_.size(this.state.existingSubcategories) > 0 &&
                        <div className="top20">
                            <h4 style={{borderTop:'1px solid gray'}} className="top20 ptop20  bot15">Existing subcategories:</h4>
                            <div>
                                { this.state.existingSubcategories.map((categoryName, index) => {
                                    return <div>{categoryName}</div>
                                })}
                            </div>
                        </div>
                        }
                    </Modal.Body>

                </Modal>
            </div>
        );
    }

}


function mapStateToProps(state, props) {
    return {
        focusAreas: state.focusAreas
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withDragAndDropContext(AdminCategoriesPage));